module.exports = __webpack_public_path__ + "static/media/glass.5bc609cd.svg";